<script setup lang="ts">
defineOptions({ name: 'AuthPassword' })
import { BForm, BInput, BInputPassword, BCheckbox } from 'best-modules/components'
import { useSso } from '../sso'
import { getErrorMessages } from '@/utils/helpers'
import AuthAccount from './AuthAccount.vue'
const { credentials, validation, submitPassword, rememberMe, links } = useSso()
</script>
<template>
  <b-form
    autocomplete="on"
    class="sso-form sso-form--password"
    hide-action-buttons
    :submit="submitPassword">
    <auth-account></auth-account>

    <b-input
      autocomplete="username"
      class="d-none"
      hide-details
      :model-value="credentials.email"
      name="username"
      readonly
      tabindex="-1"
      type="email"></b-input>

    <b-input-password
      id="sso-password"
      v-model="credentials.password"
      autocomplete="current-password"
      class="sso-field"
      :error-messages="getErrorMessages(validation.password)"
      label="Пароль"
      name="password"
      placeholder="Введіть пароль"
      @update:model-value="validation.password.$reset()"></b-input-password>

    <div class="sso-form__options">
      <b-checkbox
        v-model="rememberMe"
        class="sso-checkbox"
        hide-details
        label="Запам'ятати мене"></b-checkbox>
      <a
        v-if="links.forgotPassword"
        class="sso-link"
        :href="links.forgotPassword"
        >Забули пароль?</a
      >
    </div>

    <v-btn
      block
      class="sso-submit"
      color="primary"
      :loading="$loading.isLoading('loginWithPassword')"
      type="submit">
      {{
        $loading.isLoading('loginWithPassword') ? 'Виконується вхід…' : 'Увійти'
      }}
    </v-btn>
  </b-form>
</template>
